import { render } from "./Register.vue?vue&type=template&id=62a7c745&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=62a7c745&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62a7c745"

export default script